import { render, staticRenderFns } from "./GroupSeating.vue?vue&type=template&id=2df4e0b1&scoped=true&"
import script from "./GroupSeating.vue?vue&type=script&lang=js&"
export * from "./GroupSeating.vue?vue&type=script&lang=js&"
import style0 from "./GroupSeating.vue?vue&type=style&index=0&id=2df4e0b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df4e0b1",
  null
  
)

export default component.exports